import React from "react";
import { LogoutOutlined,AppstoreOutlined,UserOutlined } from '@ant-design/icons';
//import type { MenuProps } from 'antd';
import { Menu, Select, Button,Popconfirm, message, Spin,Avatar } from 'antd';
import {OpenLinksContext} from '../../context';
import axios from 'axios'
import efLogo from '../../assets/logo_boss.svg';
import {useNavigate} from 'react-router-dom'
import API from '../../api/api'
import Config from '../../config/pages'
import IconMap from "../../config/iconMap";
import cookie from 'react-cookies'

// 允许跨域
axios.defaults.withCredentials = true;
const { SubMenu,ItemGroup } = Menu;
//const iconsList =[<AppstoreOutlined />,<PropertySafetyOutlined/>,<ReadOutlined/>];
type Props = {};
//type MenuItem = Required<MenuProps>['items'][number];
interface IMenuInfo {
  name:string;
  routeUrl:string;
  childMenus:Array<IMenuInfo>;
  icon?: React.ReactNode
}
interface  IMenuRespListItem {
  sysName:string;
  sysHomeUrl:string;
  menuInfos:Array<IMenuInfo>;
}

// 渲染不含children的目录
const renderNoChildMenu = (item: IMenuInfo, index: string) => {
  return (<Menu.Item key={index} icon={item.icon} >{ item.name }</Menu.Item>)
  //return (<Menu.Item key={index} icon={item.icon} >{ item.name }</Menu.Item>)
}
// 渲染含有children的目录
const renderChildMenu = (item: IMenuInfo, index: string) => {
  return <SubMenu key={index} title={item.name}  icon={item.icon} >
    { 
      item.childMenus.map((child,subIndex) => {
        return renderMenu(child,index+'.'+subIndex.toString())
      })
    }
  </SubMenu>
}
// 渲染菜单
const renderMenu = (item: IMenuInfo,index: string) => {
  return item.childMenus ? renderChildMenu(item,index) : renderNoChildMenu(item,index)
}
//将多系统菜单展平
//多系统一级菜单合并平铺，子菜单层级
const flatSysMenus =(s: Array<IMenuRespListItem>)=>{
  let f:Array<IMenuInfo>=[]
  s.forEach((item,index)=>{
    //一级菜单添加图标，同系统的一级菜单图标相同
  const tmpMenus = item.menuInfos?item.menuInfos.map(m=> {return {...m,icon:IconMap[m.name]||<AppstoreOutlined />/*iconsList[index%iconsList.length]*/}}):[]
    f=[...f,...tmpMenus]
  })
  return f
}
//将多系统菜单 按系统使用menu-group TODO：KEY索引菜单将变化。
//一个系统一个group，子菜单层级
/*const groupSysMenu =(s: Array<IMenuRespListItem>)=>{
  return s.map((sys,index)=>{return<ItemGroup title={sys.sysName}>{sys.menuInfos.map((m,subIndex)=>renderMenu(m,index+'.'+subIndex))}</ItemGroup>})
}*/
//查找菜单项（叶子结点）要求key为x.x.x索引
const findMenuByKey = (menus:IMenuInfo[],key:string)=>{
  const level = key.split(".")
  console.log("findMenuByKey",key, level)
  if(level.length===1){
    return menus[parseInt(level[0])]
  }else{
    let m=menus
    for(let i=0; i<level.length-1; i++){
      m=m[parseInt(level[i])].childMenus
    }
    return m[parseInt(level[level.length-1])]
  }
}

//根据key查找host
const findHostByKey = (sys:Array<IMenuRespListItem>,key:string)=>{
  let first  = parseInt(key.split(".")[0]);
  let index = 0
  for(var s of sys){
    if(s.menuInfos && s.menuInfos.length>0 && first<s.menuInfos.length){
      //found
      return sys[index].sysHomeUrl
    }else{
      first=first-s.menuInfos.length
    }
    index++
  }
}

const Sidebar = (props: Props) => {
  /*const onClick: MenuProps['onClick'] = (e) => {
    console.log('click ', e);
  };*/
  //useNavigate
  const navigate = useNavigate()
  const confirm = (e?: React.MouseEvent<HTMLElement>) => {
    console.log(e);
    Config.SIGNOUT_3RD_URL.map(url=>{
      axios.get(url)
      .then(res=>{
        console.log("SIGNOUT_3RD_URL",res)
        if(res.status===302){
          const redirectUrl = res.headers['location']
          axios.get(redirectUrl)
          .then(rres=>{
            //
            console.log("redirect response",rres)
          })
          .catch(err=>{
            console.log("redirect err",err)
          })
        }
      })
      .catch(function (error) {
  
      })
    })
   
    
    //message.success('成功退出登录');
    const token = window.localStorage.getItem("token")
    //clear storage and cookie
    window.localStorage.removeItem("token")
    window.localStorage.removeItem("email")

    const token_name = cookie.load('token_name') || 'token'
    cookie.remove('token_name')
    cookie.remove(token_name,{domain: '.english1.cn',path: '/',secure: true})
    //cookie.remove('email')
    //set signout 3rd flag,for signin page use
    //window.localStorage.setItem("signout3rd","1")
    //logout&redirect
    window.location.href=API.logout+"?token="+token
  };
  const cancel = (e?: React.MouseEvent<HTMLElement>) => {
    console.log(e);
  };
  React.useEffect(() => {

  }, []);

  const refSelect:any = React.useRef(null);
  const [searchSelect,setSearchSelect] = React.useState("")
  return (
    /*
    <div className="grid justify-center bg-slate-100 p-4">
      <Image className="mt-8 w-24" src={efLogo} alt="Yingfu logo" />
    </div>*/
      <div className="flex  flex-col h-full">
        <div className="p-[10px] flex justify-center items-start">
            <img className="w-[160px]" src={efLogo} alt=""></img>
        </div>
        <div className="p-[10px]">
          <OpenLinksContext.Consumer>
          { 
            (context)=>{
              const onChange = (value: string) => {
                console.log(`selected ${value}`);
              };
              
              const onSearch = (value: string) => {
                console.log('search:', value);
              };
              const onFocus=()=>{
                console.log("focus")
              }
              const getLeafMenus = (menus:IMenuInfo[])=>{
                const result:any=[];
                loopLeafMenus(menus,result,'')
                console.log("result",result)
                //path有可能相同 避免option的key重复 增加唯一index做Url无效参数
                //let options = result.map((r:IOption,index:number)=>({value:r.value,label:r.label}))
                //console.log("options",options)
                return result
              }
              function loopLeafMenus(menus: IMenuInfo[],leafMenus:any[],prefix:string) {
                let index = 0
                  //console.log("menus",menus)
                  for(const menu of menus){
                    if (menu.childMenus===null) {
                      //console.log(menu);
                      leafMenus.push({value:prefix+(index++),label:menu.name});
                      continue;
                    }
                    loopLeafMenus(menu.childMenus,leafMenus,prefix+(index++)+'.');
                  }
              }
              
              //<Input  size="small" placeholder={'搜索菜单'+context.menus.length} prefix={<SearchOutlined className="site-form-item-icon" />} />
              return(
                <Select  showSearch placeholder="搜索菜单" size="small" style={{ width: '100%' }} allowClear={true} ref={refSelect}
                    optionFilterProp="children" value={searchSelect}
                    onChange={onChange} onSearch={onSearch} onFocus={onFocus} 
                    onSelect={(v)=>{
                      const menu = findMenuByKey(flatSysMenus(context.menus),v)
                      context.add(v,menu.name,menu.routeUrl.toLowerCase().startsWith("http")?menu.routeUrl:(findHostByKey(context.menus,v)+menu.routeUrl));
                      if(refSelect.current){
                        console.log("ready blur",refSelect.current)
                        refSelect.current.blur()
                      }
                    }}
                    filterOption={(input, option) =>
                      ((option?.label ?? '')+'').toLowerCase().includes(input.toLowerCase())
                    }
                    options={getLeafMenus(flatSysMenus(context.menus))}
                  />
              )
            }
          }
          </OpenLinksContext.Consumer>
        </div>
        <div className="min-h-[200px]  h-[calc(100%-160px)] overflow-auto">
          <OpenLinksContext.Consumer>
            { (context)=>{
              if(context.init){
                return(
                  <Menu
                    onClick={(e)=>{
                      //check other window signout]
                      if(!window.localStorage.getItem('token')){
                        navigate("/signin")
                        return
                      }
                      //菜单点击动作校验
                      axios.get(API.validUser,{headers: {'EFToken':window.localStorage.getItem('token')}})
                      .then(res=>{
                        console.log("validUser",res)
                      })
                      .catch(function (error) {
                        if(error && error.response && error.response.status == 401){
                          message.error('登录状态失效，请重新登录',1)
                          window.localStorage.removeItem("token")
                          window.localStorage.removeItem("email")

                          const token_name = cookie.load('token_name') || 'token'
                          cookie.remove('token_name')
                          cookie.remove(token_name,{domain: '.english1.cn',path: '/',secure: true})
                          //cookie.remove('email')  
                          //set signout 3rd flag,for signin page use
                          //window.localStorage.setItem("signout3rd","1")

                          Config.SIGNOUT_3RD_URL.map(url=>{
                            axios.get(url)
                            .then(res=>{
                              console.log(res)
                            })
                            .catch(function (error) {
                        
                            })
                          })
                          navigate('/signin')
                        }
                      })
                      console.log('click ', e, context.menus);  
                      const destMenu = findMenuByKey(flatSysMenus(context.menus),e.key);
                      //check MAX
                      console.log("router is "+context.routes.urls.length)
                      if(context.routes && context.routes.urls && context.routes.urls.length >= Config.MAX_TAB){
                        message.error('最多打开'+Config.MAX_TAB+'个标签页',1);
                        return
                      }//menu.routeUrl.toLowerCase().startsWith("http")?menu.routeUrl:(findHostByKey(context.menus,v)+menu.routeUrl)
                      context.add(e.key,destMenu.name,/*destMenu.routeUrl*/
                        destMenu.routeUrl.toLowerCase().startsWith("http")?destMenu.routeUrl:(findHostByKey(context.menus,e.key)+destMenu.routeUrl));
                      console.log("findMenuByKey", findMenuByKey(flatSysMenus(context.menus),e.key));
                      console.log("findHostByKey "+e.key,findHostByKey(context.menus,e.key))
                    }}
                    defaultSelectedKeys={['1']}
                    defaultOpenKeys={['sub1']}
                    mode="inline"
                    //items={items}
                    theme="dark"
                  >
                    { 
                      flatSysMenus(context.menus).map((m,index)=>renderMenu(m,index.toString()))     
                      //groupSysMenu(context.menus)   TODO        
                    }
                  </Menu>
                )
              }else{
                return(<div className="h-full  flex justify-center items-center"><Spin/></div>)
              }
            }
          }
          </OpenLinksContext.Consumer>
        </div>
        <div className="p-[10px] flex flex-col justify-center items-center text-white bg-[#011529]">
          <div className="flex justify-center items-center">
            <Avatar    size={20} icon={<UserOutlined />} />
            <div className="text-base" >{window.localStorage.getItem("email")}</div>
          </div>
          <Popconfirm title="退出登录" description="请确认是否退出登录?" placement="rightBottom"
            onConfirm={confirm} onCancel={cancel} okText="确认"  cancelText="取消">
            <Button className="flex  justify-center items-center text-xs" type="link" >
              <span>退出登录</span><LogoutOutlined />
            </Button>
          </Popconfirm>
        </div>
      </div>
  );
};


export default Sidebar;
